// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "html,\nbody {\n  padding: 0;\n  margin: 0;\n  height: 100vh;\n  background-color: #111620;\n}\n", "",{"version":3,"sources":["/app/src/views/localtion/localtion.vue"],"names":[],"mappings":"AAKA;;EAEE,UAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;AAJF","file":"localtion.vue","sourcesContent":["\n\n\n\n\nhtml,\nbody {\n  padding: 0;\n  margin: 0;\n  height: 100vh;\n  background-color: #111620;\n}\n"]}]);
// Exports
module.exports = exports;
